<script lang="ts" setup></script>

<template>
  <div class="flex max-w-[675px] m-auto mt-8 text-center content-center">
    <div class="grow content-center">
      <hr class="border-gray-400">
    </div>
    <div class="uppercase px-2 content-center font-medium text-gray-400">
      {{ $t('or') }}
    </div>
    <div class="grow content-center">
      <hr class="border-gray-400">
    </div>
  </div>
</template>
